// Minutes and seconds left: "0:59", or "09:59" with `isMinutesPadded` (the cart timer's format).
const formatCountdown = (remainingMs, { isMinutesPadded = false } = {}) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000))
  const minutes = String(Math.floor(totalSeconds / 60))
  return `${isMinutesPadded ? minutes.padStart(2, "0") : minutes}:${String(totalSeconds % 60).padStart(2, "0")}`
}

export default formatCountdown
